import { MenuItem, styled } from '@mui/material';

export const FilterMenuItem = styled(MenuItem)(({ theme }) => ({
    padding: theme.spacing(1.5),
    height: theme.spacing(7.75),
    gap: theme.spacing(1.5),
}));
